export default {
  methods: {
    clearText() {
      document.gift_code_serial_form.submit()
    }
  }
}
